import { collection, getDocs, limit, query, startAfter, where } from 'firebase/firestore';
import { db } from '../firebase';
import { calculateRegistrantScoreAndAward, isAwardSyncNeeded } from './scoringCalculator';
import { fetchVideoPenaltyConfig } from './videoPenaltyConfig';

async function readPages(collectionName, constraints) {
    const records = [];
    let cursor;
    while (true) {
        const page = await getDocs(query(collection(db, collectionName), ...constraints,
            ...(cursor ? [startAfter(cursor)] : []), limit(100)));
        records.push(...page.docs.map(document => ({ ...document.data(), id: document.id })));
        if (page.docs.length < 100) return records;
        cursor = page.docs[page.docs.length - 1];
    }
}

// Load only this event and scores linked to its registrations, including legacy scores without eventId.
export async function loadEventResultEmailRows(eventId) {
    if (eventId !== 'APCS2026') throw new Error('Winner email campaigns are available only for APCS2026.');
    const config = await fetchVideoPenaltyConfig(eventId);
    const registrants = await readPages('Registrants2025', [where('eventId', '==', eventId)]);
    const scoresByRegistrant = new Map();
    for (let index = 0; index < registrants.length; index += 10) {
        const scores = await readPages('JuryScores2025', [where('registrantId', 'in',
            registrants.slice(index, index + 10).map(registrant => registrant.id))]);
        scores.forEach(score => {
            if (!scoresByRegistrant.has(score.registrantId)) scoresByRegistrant.set(score.registrantId, []);
            scoresByRegistrant.get(score.registrantId).push(score);
        });
    }
    return registrants.map(registrant => {
        const scores = scoresByRegistrant.get(registrant.id) || [];
        const scoring = calculateRegistrantScoreAndAward(scores, registrant, config);
        return { registrant, isFinalized: scores.length > 0 && scores.every(score => score.isFinalized === true),
            needsAwardSync: isAwardSyncNeeded(registrant, scoring) };
    });
}
